import React from 'react';
import Text from '../text';

const AccordionItemTitle = (props) => {
  return <Text variant="body2" classes="f-gl-400 f-size-12 p-10 pb-0" text={props.title} />;
};

export default AccordionItemTitle;
